import * as React from 'react';
import { connect } from 'react-redux';
import { UIModeState } from '../../reducers/uimode';
import { ToolbarDirection, setTTSMode } from '../../actions/UIModeAction';
import PrimaryToolbar from '../common/PrimaryToolbar';
import { AppStates } from '../../../../..';
import HeaderToolbarBaseLevel from './HeaderToolbarBaseLevel';
import HeaderToolbarSelectionLevel from '../selection/HeaderToolbarSelectionLevel';
import HeaderToolbarZoomLevel from '../zoom/HeaderToolbarZoomLevel';
import HeaderToolbarFreehandPenLevel from '../drawing/freehand-pen/HeaderToolbarFreehandPenLevel';
import HeaderToolbarImagePastingLevel from '../imagepasting/HeaderToolbarImagePastingLevel';
import HeaderToolbarObjectDrawingLevel
  from '../drawing/object-drawing/HeaderToolbarObjectDrawingLevel';
import HeaderToolbarReflowableContentLevel
  from '../reflowable-content/HeaderToolbarReflowableContentLevel';
import HeaderToolbarSNELevel from '../sne/HeaderToolbarSNELevel';
import HeaderToolbarTextboxLevel from '../textbox/HeaderToolbarTextboxLevel';
import HeaderToolbarAllErasingLevel from '../drawing/HeaderToolbarAllErasingLevel';
import HeaderToolbarAllErasingUndoRedoLevel from '../drawing/HeaderToolbarAllErasingUndoRedoLevel';
import TextboxSecondaryLevel from '../textbox/TextboxSecondaryLevel';
import ReflowableContentSelectionSettingSecondaryLevel
  from '../reflowable-content/ReflowableContentSelectionSettingSecondaryLevel';
import ReflowableContentZoomSettingSecondaryLevel
  from '../reflowable-content/ReflowableContentZoomSettingSecondaryLevel';
import ReflowableContentMarkerSettingSecondaryLevel
  from '../reflowable-content/ReflowableContentMarkerSettingSecondaryLevel';
import TTSSettingSecondaryLevel from '../tts/TTSSettingSecondaryLevel';
import HeaderToolbarHanderasingLevel from '../drawing/freehand-pen/HeaderToolbarHanderasingLevel';
import HeaderToolbarExtraToolsLevel from '../extra-tools/HeaderToolbarExtraToolsLevel';
import { DialogType } from '../common/SettingDialogContainer';
import { Dispatch, Action } from 'redux';
import UIAction from '../../actions/ui/UIAction';
import { CurrentTool } from '../../reducers/ui/ui';
import HeaderToolbarLearningPenLevel from '../learning-pen/HeaderToolbarLearningPenLevel';
import LearningPenLevelSecondaryLevel from '../learning-pen/LearningPenLevelSecondaryLevel';
import LearningPenVisibilitySecondaryLevel
from '../learning-pen/LearningPenVisibilitySecondaryLevel';

interface NewHeaderToolbarProps {
  uimode: UIModeState;
  dispatch: Dispatch<Action>;
  setDialogType: (dialogType: DialogType) => void;
}

export enum Level {
  Base,
  Selection,
  Zoom,
  FreehandPen,
  ImagePasting,
  ObjectDrawing,
  ReflowableContent,
  SNE,
  Textbox,
  ExtraTools,
  Handerasing,
  AllErasing,
  AllErasingUndoRedo,
  LearningPen,
}

export enum SecondaryToolbarType {
  None,
  Textbox,
  ReflowableContentSelectionSetting,
  ReflowableContentZoomSetting,
  ReflowableContentMarkerSetting,
  TTS,
  SNE,
  LearningPen,
  LearningPenVisibility,
}

export const LevelContext = React.createContext([Level.Base]);

interface NewHeaderToolbarState {
  levels: Level[];
  dialogType: DialogType;
  secondaryToolbarType: SecondaryToolbarType;
}

class NewHeaderToolbar extends React.PureComponent<NewHeaderToolbarProps, NewHeaderToolbarState> {
  private pushLevel = (level: Level) => {
    // レベル変更時にTTSMode解除
    // TODO: Refactor
    setTTSMode(false, this.props.dispatch);

    this.setState({
      levels: [...this.state.levels, level],
      secondaryToolbarType: SecondaryToolbarType.None,
    });
  }

  private popLevel = () => {
    // レベル変更時にTTSMode解除
    // TODO: Refactor
    setTTSMode(false, this.props.dispatch);
    const levels = this.state.levels.slice(0, -1);
    const currentLevel = levels[levels.length - 1];
    if (currentLevel === Level.Base) {
      // XXX: トップレベルへ切り替えるタイミングで強制的にズーム/パン/紙面ツールに持ち変える
      // FIXME: 最終仕様未決定
      UIAction.setCurrentTool(CurrentTool.Touch, this.props.dispatch);
    }
    this.setState({
      levels: [...levels],
      secondaryToolbarType: SecondaryToolbarType.None,
    });
  }

  private popToTopLevel = () => {
    // レベル変更時にTTSMode解除
    // TODO: Refactor
    setTTSMode(false, this.props.dispatch);

    // XXX: トップレベルへ切り替えるタイミングで強制的にズーム/パン/紙面ツールに持ち変える
    // FIXME: 最終仕様未決定
    UIAction.setCurrentTool(CurrentTool.Touch, this.props.dispatch);

    this.setState({
      levels: [Level.Base],
      secondaryToolbarType: SecondaryToolbarType.None,
    });
  }

  private setSecondaryToolbarType = (secondaryToolbarType: SecondaryToolbarType) => {
    // TTSのSecondaryToolbar表示時にTTSModeに設定しクリックで再生出来るようにする
    // TODO: Refactor
    switch (secondaryToolbarType) {
      case SecondaryToolbarType.TTS:
        setTTSMode(true, this.props.dispatch);
        break;
      default:
        setTTSMode(false, this.props.dispatch);
        break;
    }

    this.setState({ secondaryToolbarType });
  }

  private createLevel(): JSX.Element {
    const isVertical = (this.props.uimode.toolbarDirection !== ToolbarDirection.Horizontal);
    const attrs = {
      isVertical,
      pushLevel: this.pushLevel,
      popLevel: this.popLevel,
      popToTopLevel: this.popToTopLevel,
      setDialogType: this.props.setDialogType,
      setSecondaryToolbarType: this.setSecondaryToolbarType,
    };

    const currentLevel = this.state.levels[this.state.levels.length - 1];
    switch (currentLevel) {
      case Level.Base:
        return <HeaderToolbarBaseLevel { ...attrs } />;
      case Level.Selection:
        return <HeaderToolbarSelectionLevel { ...attrs } />;
      case Level.Zoom:
        return <HeaderToolbarZoomLevel { ...attrs } />;
      case Level.FreehandPen:
        return <HeaderToolbarFreehandPenLevel { ...attrs } />;
      case Level.ImagePasting:
        return <HeaderToolbarImagePastingLevel { ...attrs } />;
      case Level.ObjectDrawing:
        return <HeaderToolbarObjectDrawingLevel { ...attrs } />;
      case Level.ReflowableContent:
        return <HeaderToolbarReflowableContentLevel { ...attrs } />;
      case Level.Textbox:
        return <HeaderToolbarTextboxLevel { ...attrs } />;
      case Level.SNE:
        return <HeaderToolbarSNELevel { ...attrs } />;
      case Level.ExtraTools:
        return <HeaderToolbarExtraToolsLevel { ...attrs } />;
      case Level.Handerasing:
        return <HeaderToolbarHanderasingLevel { ...attrs } />;
      case Level.AllErasing:
        return <HeaderToolbarAllErasingLevel { ...attrs } />;
      case Level.AllErasingUndoRedo:
        return <HeaderToolbarAllErasingUndoRedoLevel { ...attrs } />;
      case Level.LearningPen:
        return <HeaderToolbarLearningPenLevel { ...attrs } />;
    }
  }

  private createSecondaryToolbar(): JSX.Element | null {
    const { toolbarDirection } = this.props.uimode;

    const attrs = {
      direction: toolbarDirection,
      setDialogType: this.props.setDialogType,
      setSecondaryToolbarType: this.setSecondaryToolbarType,
    };

    switch (this.state.secondaryToolbarType) {
      case SecondaryToolbarType.None:
        return null;
      case SecondaryToolbarType.Textbox:
        return <TextboxSecondaryLevel { ...attrs } />;
      case SecondaryToolbarType.ReflowableContentSelectionSetting:
        return <ReflowableContentSelectionSettingSecondaryLevel { ...attrs } />;
      case SecondaryToolbarType.ReflowableContentZoomSetting:
        return <ReflowableContentZoomSettingSecondaryLevel { ...attrs } />;
      case SecondaryToolbarType.ReflowableContentMarkerSetting:
        return <ReflowableContentMarkerSettingSecondaryLevel { ...attrs } />;
      case SecondaryToolbarType.TTS:
        return <TTSSettingSecondaryLevel { ...attrs } />;
      case SecondaryToolbarType.LearningPen:
        return <LearningPenLevelSecondaryLevel { ...attrs } />;
      case SecondaryToolbarType.LearningPenVisibility:
        return <LearningPenVisibilitySecondaryLevel { ...attrs } />;
      case SecondaryToolbarType.SNE:
        return null;
    }
  }

  public constructor(props: NewHeaderToolbarProps) {
    super(props);

    this.state = {
      levels: [Level.Base],
      dialogType: DialogType.None,
      secondaryToolbarType: SecondaryToolbarType.None,
    };
  }

  public render() {
    const { toolbarDirection } = this.props.uimode;

    return (
      <PrimaryToolbar direction={toolbarDirection}>
        {this.createLevel()}
        {this.createSecondaryToolbar()}
      </PrimaryToolbar>
    );
  }
}

const mapStateToProps = (appStates: AppStates) => ({ uimode: appStates.uimode });

export default connect(mapStateToProps)(NewHeaderToolbar);
